import { Link, useLocation, useParams } from 'react-router-dom'
import { formatKickoffLongDateTime } from '@/lib/kickoff'
import { useTranslation } from '@/i18n'

interface MatchChatLocationState {
  homeName?: string
  awayName?: string
  homeLogo?: string
  awayLogo?: string
  kickoff?: string
  writable?: boolean
}

export function MatchChatPage() {
  const { t } = useTranslation()
  const { matchId } = useParams()
  const { state } = useLocation()
  const chatState = (state as MatchChatLocationState | null) ?? null

  return (
    <div className="space-y-5">
      <section className="rounded-[1.35rem] border border-[#111827] bg-[#050607] p-5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#3f7890]">
          {t('Match chat')}
        </p>
        <h1 className="mt-3 text-2xl font-black tracking-tight text-white">
          {chatState?.homeName && chatState?.awayName
            ? `${chatState.homeName} vs ${chatState.awayName}`
            : `${t('Wedstrijd')} ${matchId ?? ''}`}
        </h1>
        <p className="mt-2 text-sm text-surface-400">
          {t('De chatview zelf bouwen we later uit. De access-check vanuit de match detail werkt nu al.')}
        </p>
      </section>

      <section className="rounded-[1.35rem] border border-[#202427] bg-[#0a0d0f] p-5">
        <div className="grid gap-3 sm:grid-cols-2">
          <InfoCard label={t('Chat status')} value={chatState?.writable ? t('Schrijfbaar') : t('Alleen lezen of nog niet bekend')} />
          <InfoCard label={t('Aftrap')} value={formatKickoff(chatState?.kickoff)} />
        </div>

        <div className="mt-5 flex flex-wrap gap-3">
          <Link
            to="/dashboard/poules"
            className="inline-flex rounded-full border border-[#202427] bg-[#0d1113] px-4 py-2 text-sm font-semibold text-surface-200 transition hover:border-[#24405b] hover:bg-[#151a1c]"
          >
            {t('Terug naar dashboard')}
          </Link>
        </div>
      </section>
    </div>
  )
}

function InfoCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-[1rem] bg-[#0d1011] p-4">
      <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-surface-500">
        {label}
      </p>
      <p className="mt-2 text-sm font-semibold text-white">{value}</p>
    </div>
  )
}

function formatKickoff(value?: string) {
  return formatKickoffLongDateTime(value)
}
